import useComponentWidth from 'hooks/useComponentWidth'
import map from 'lodash/map'
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { CONSTANTS_FORM_BUILDER } from 'utils/FormBuilder/ConstantsFormBuilder'

import BuilderAddButton from './BuilderAddButton'
import BuilderRow from './BuilderRow'
import DroppableRow from './DroppableRow'

function BuilderSection({ sectionId }) {
  const builderSectionContainer = React.useRef(null)
  const { rowsArray, questionsArray, getSection, getPage, reorderSourceRow } =
    React.useContext(FormBuilderContext)

  const rowHasQuestions = React.useCallback(
    (row) => Boolean(questionsArray?.find((q) => q.row === row.id)),
    [questionsArray]
  )

  const rows = rowsArray
    .filter((r) => r.section === sectionId && rowHasQuestions(r))
    .sort((a, b) => a.order - b.order)

  const builderSectionWidth = useComponentWidth(builderSectionContainer)

  const isDropDisabled = React.useCallback(() => {
    if (!reorderSourceRow) return false

    const targetSection = getSection(sectionId)
    if (!targetSection) return false

    const targetPage = getPage(targetSection.page)
    const targetIsRepeatSection = Boolean(targetPage?.repeat_section)

    const sourceQuestion = questionsArray.find(
      (q) => q.row === reorderSourceRow
    )
    if (!sourceQuestion) return false

    const sourceSection = getSection(sourceQuestion.section)
    if (!sourceSection) return false

    const sourcePage = getPage(sourceSection.page)
    const sourceIsRepeatSection = Boolean(sourcePage?.repeat_section)

    return targetIsRepeatSection !== sourceIsRepeatSection
  }, [reorderSourceRow, sectionId, questionsArray, getSection, getPage])

  return (
    <div className="pt-0.5" ref={builderSectionContainer}>
      {map(rows, (row, i) => (
        <React.Fragment key={row.id}>
          <DroppableRow
            isFirst={i === 0}
            rowId={row.id}
            sectionId={sectionId}
          />
          {/* <Space small> */}
          <BuilderRow
            builderSectionWidth={builderSectionWidth}
            rowId={row.id}
          />
          {/* </Space> */}
        </React.Fragment>
      ))}
      <Droppable
        isCombineEnabled
        droppableId={`addRowTo_${sectionId}`}
        isDropDisabled={isDropDisabled()}
        type="TASK"
      >
        {(provided, snapshot) => (
          <div
            className="-mx-1 grid grid-cols-1 pt-1 sm:grid-cols-12"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <BuilderAddButton
              isSelectableItem
              containerClassNames="px-1"
              id={sectionId}
              isHighlighted={snapshot.isDraggingOver}
              spacingTop={0}
              type={CONSTANTS_FORM_BUILDER.SELECTION_TYPE.ROW_ADD}
            >
              +
            </BuilderAddButton>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  )
}

export default BuilderSection
